import { render, staticRenderFns } from "./PieCharts.vue?vue&type=template&id=08c229ed&scoped=true&"
import script from "./PieCharts.vue?vue&type=script&lang=js&"
export * from "./PieCharts.vue?vue&type=script&lang=js&"
import style0 from "./PieCharts.vue?vue&type=style&index=0&id=08c229ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c229ed",
  null
  
)

export default component.exports